export const ADMIN_PAGE_PERMISSIONS = Object.freeze({
  '/': 'view_dashboard',
  '/applications': 'review_applications',
  '/users': 'view_users_roles',
  '/admin-accounts': 'manage_admin_accounts',
  '/stewards': 'view_partner_network',
  '/stewards/:id': 'view_partner_network',
  '/pa': 'view_partner_network',
  '/pa/:id': 'view_partner_network',
  '/rp': 'view_partner_network',
  '/kuds': 'view_partner_network',
  '/kuds/:id': 'view_partner_network',
  '/puskud': 'view_partner_network',
  '/rps': 'view_partner_network',
  '/rps/:id': 'view_partner_network',
  '/partners': 'view_partner_network',
  '/partners/:id': 'view_partner_network',
  '/steward-changes': 'review_steward_changes',
  '/units': 'view_units',
  '/units/:id': 'view_units',
  '/device-bindings': 'view_units',
  '/sim-cards': 'view_sim_cards',
  '/device-alerts': 'view_device_alerts',
  '/notifications': 'view_device_alerts',
  '/steward-checkins': 'review_steward_checkins',
  '/firmware': 'manage_firmware',
  '/firmware/upgrade': 'manage_firmware',
  '/firmware/upload': 'manage_firmware',
  '/firmware/list': 'manage_firmware',
  '/firmware/monitor': 'manage_firmware',
  '/finance': 'view_finance',
  '/transactions': 'view_finance',
  '/withdrawals': 'view_finance',
  '/profit-sharing-finance': 'view_finance',
  '/bank-accounts': 'view_bank_accounts',
  '/cards': 'view_physical_cards',
  '/profit-rules': 'manage_profit_rules',
  '/settings': 'manage_business_settings',
  '/settings/growth': 'manage_business_settings',
  '/audit': 'view_audit_logs',
  '/device-offline-analysis': 'view_device_offline_analysis',
  '/runtime-logs': 'view_runtime_logs',
  '/content': 'manage_content'
});

export const ADMIN_PERMISSION_KEYS = Object.freeze([
  'view_dashboard', 'review_applications', 'view_users_roles', 'manage_users_roles',
  'manage_admin_accounts', 'view_partner_network', 'manage_partner_bindings', 'review_steward_changes', 'view_units',
  'edit_units', 'manage_unit_pricing', 'control_units', 'view_sim_cards', 'manage_sim_cards', 'view_device_alerts', 'resolve_device_alerts',
  'manage_alert_notifications', 'review_steward_checkins', 'manage_firmware', 'view_finance',
  'approve_finance_actions', 'view_physical_cards', 'manage_physical_cards', 'write_physical_card_value',
  'view_bank_accounts', 'manage_bank_accounts', 'reveal_bank_accounts',
  'view_payouts', 'manage_payouts', 'approve_payouts',
  'manage_profit_rules', 'manage_business_settings', 'manage_permissions', 'view_audit_logs',
  'view_device_offline_analysis', 'view_device_offline_raw_logs', 'reanalyze_device_offline_analysis',
  'view_runtime_logs', 'manage_content'
]);

const PERMISSION_METADATA = Object.freeze({
  view_dashboard: ['运营监控', '页面'], review_applications: ['运营监控', '操作'],
  view_users_roles: ['用户与角色', '页面'], manage_users_roles: ['用户与角色', '操作', ['view_users_roles']],
  view_partner_network: ['用户与角色', '页面', ['view_users_roles', 'view_units']], manage_partner_bindings: ['用户与角色', '操作', ['view_partner_network', 'view_users_roles']],
  review_steward_changes: ['设备运维', '操作', ['view_partner_network', 'view_users_roles']], view_units: ['设备运维', '页面'],
  edit_units: ['设备运维', '操作', ['view_units', 'view_users_roles']], manage_unit_pricing: ['设备运维', '高风险操作', ['view_units']], control_units: ['设备运维', '高风险操作', ['view_units']],
  view_sim_cards: ['设备运维', '页面'], manage_sim_cards: ['设备运维', '操作', ['view_sim_cards', 'view_units']],
  view_device_alerts: ['设备运维', '页面'], resolve_device_alerts: ['设备运维', '操作', ['view_device_alerts']], manage_alert_notifications: ['设备运维', '操作', ['view_device_alerts']],
  review_steward_checkins: ['设备运维', '操作', ['view_partner_network', 'view_units']], manage_firmware: ['设备运维', '高风险操作'],
  view_finance: ['财务中心', '页面'], approve_finance_actions: ['财务中心', '高风险操作', ['view_finance']],
  view_bank_accounts: ['财务中心', '页面', ['view_finance']], manage_bank_accounts: ['财务中心', '操作', ['view_bank_accounts']], reveal_bank_accounts: ['财务中心', '敏感数据', ['view_bank_accounts']],
  view_payouts: ['财务中心', '页面', ['view_finance']], manage_payouts: ['财务中心', '高风险操作', ['view_payouts']], approve_payouts: ['财务中心', '高风险操作', ['view_payouts']],
  view_physical_cards: ['财务中心', '页面'], manage_physical_cards: ['财务中心', '操作', ['view_physical_cards']], write_physical_card_value: ['财务中心', '高风险操作', ['manage_physical_cards']], manage_profit_rules: ['财务中心', '高风险操作', ['view_finance']],
  manage_business_settings: ['系统管理', '页面'], manage_permissions: ['系统管理', '系统专属', ['manage_business_settings'], false], manage_admin_accounts: ['系统管理', '系统专属', [], false],
  view_audit_logs: ['系统管理', '页面'],
  view_device_offline_analysis: ['系统管理', '页面'],
  view_device_offline_raw_logs: ['系统管理', '敏感数据', ['view_device_offline_analysis']],
  reanalyze_device_offline_analysis: ['系统管理', '操作', ['view_device_offline_analysis']],
  view_runtime_logs: ['系统管理', '页面'], manage_content: ['系统管理', '操作']
});

// This is intentionally a navigation tree, not another set of permissions.
// A repeated function key means that the current product intentionally shares
// one page-entry permission across more than one left-navigation page.
export const ADMIN_PERMISSION_TREE = Object.freeze([
  Object.freeze({ label: '运营监控', pages: Object.freeze([
    Object.freeze({ label: '仪表板', routes: Object.freeze(['/']), functionKeys: Object.freeze(['view_dashboard']) }),
    Object.freeze({ label: '加入申请', routes: Object.freeze(['/applications']), functionKeys: Object.freeze(['review_applications']) })
  ]) }),
  Object.freeze({ label: '用户与角色', pages: Object.freeze([
    Object.freeze({ label: '用户与业务角色', routes: Object.freeze(['/users']), functionKeys: Object.freeze(['view_users_roles', 'manage_users_roles']) }),
    Object.freeze({ label: 'PA、RP 与水管家资料', routes: Object.freeze(['/stewards', '/pa', '/rp']), functionKeys: Object.freeze(['view_partner_network', 'manage_partner_bindings']) })
  ]) }),
  Object.freeze({ label: '设备运维', pages: Object.freeze([
    Object.freeze({ label: '水站管理', routes: Object.freeze(['/units']), functionKeys: Object.freeze(['view_units', 'edit_units', 'manage_unit_pricing', 'control_units']) }),
    Object.freeze({ label: 'SIM 卡管理', routes: Object.freeze(['/sim-cards']), functionKeys: Object.freeze(['view_sim_cards', 'manage_sim_cards']) }),
    Object.freeze({ label: '设备告警', routes: Object.freeze(['/device-alerts', '/notifications']), functionKeys: Object.freeze(['view_device_alerts', 'resolve_device_alerts', 'manage_alert_notifications']) }),
    Object.freeze({ label: '水管家巡检', routes: Object.freeze(['/steward-checkins']), functionKeys: Object.freeze(['review_steward_checkins']) }),
    Object.freeze({ label: '水管家换人审核', routes: Object.freeze(['/steward-changes']), functionKeys: Object.freeze(['review_steward_changes']) }),
    Object.freeze({ label: '固件升级', routes: Object.freeze(['/firmware/upgrade']), functionKeys: Object.freeze(['manage_firmware']) })
  ]) }),
  Object.freeze({ label: '财务中心', pages: Object.freeze([
    Object.freeze({ label: '财务管理', routes: Object.freeze(['/finance']), functionKeys: Object.freeze(['view_finance', 'approve_finance_actions']), sharedKeys: Object.freeze(['view_finance']) }),
    Object.freeze({ label: '交易明细', routes: Object.freeze(['/transactions']), functionKeys: Object.freeze(['view_finance']), sharedKeys: Object.freeze(['view_finance']) }),
    Object.freeze({ label: '收入分配', routes: Object.freeze(['/profit-sharing-finance']), functionKeys: Object.freeze(['view_finance']), sharedKeys: Object.freeze(['view_finance']) }),
    Object.freeze({ label: '实体水卡', routes: Object.freeze(['/cards']), functionKeys: Object.freeze(['view_physical_cards', 'manage_physical_cards', 'write_physical_card_value']) }),
    Object.freeze({ label: '银行卡与应付', routes: Object.freeze(['/bank-accounts']), functionKeys: Object.freeze(['view_bank_accounts', 'manage_bank_accounts', 'reveal_bank_accounts', 'view_payouts', 'manage_payouts', 'approve_payouts']) }),
    Object.freeze({ label: '收入分配规则', routes: Object.freeze(['/profit-rules']), functionKeys: Object.freeze(['manage_profit_rules']) })
  ]) }),
  Object.freeze({ label: '系统管理', pages: Object.freeze([
    Object.freeze({ label: '系统设置', routes: Object.freeze(['/settings']), functionKeys: Object.freeze(['manage_business_settings']) }),
    Object.freeze({ label: '用户裂变设置', routes: Object.freeze(['/settings/growth']), functionKeys: Object.freeze(['manage_business_settings']), sharedKeys: Object.freeze(['manage_business_settings']) }),
    Object.freeze({ label: '系统审计', routes: Object.freeze(['/audit']), functionKeys: Object.freeze(['view_audit_logs']) }),
    Object.freeze({ label: '设备断网分析', routes: Object.freeze(['/device-offline-analysis']), functionKeys: Object.freeze(['view_device_offline_analysis', 'view_device_offline_raw_logs', 'reanalyze_device_offline_analysis']) }),
    Object.freeze({ label: '运行日志', routes: Object.freeze(['/runtime-logs']), functionKeys: Object.freeze(['view_runtime_logs']) }),
    Object.freeze({ label: '内容管理', routes: Object.freeze(['/content']), functionKeys: Object.freeze(['manage_content']) })
  ]) })
]);

export const ADMIN_PERMISSION_CATALOG = Object.freeze(ADMIN_PERMISSION_KEYS.map((functionKey) => {
  const [group, kind, requires = [], delegatable = true] = PERMISSION_METADATA[functionKey];
  return Object.freeze({ functionKey, group, kind, requires: Object.freeze(requires), delegatable });
}));

const normalizePath = (pathname) => {
  const value = String(pathname || '/').split('?')[0].split('#')[0];
  if (value === '/') return value;
  return value.replace(/\/+$/, '') || '/';
};

const matchesPattern = (pathname, pattern) => {
  const pathSegments = normalizePath(pathname).split('/').filter(Boolean);
  const patternSegments = normalizePath(pattern).split('/').filter(Boolean);
  return pathSegments.length === patternSegments.length && patternSegments.every((segment, index) => (
    segment.startsWith(':') || segment === pathSegments[index]
  ));
};

export const getPagePermission = (pathname, pagePermissions = ADMIN_PAGE_PERMISSIONS) => {
  const normalized = normalizePath(pathname);
  if (pagePermissions?.[normalized]) return pagePermissions[normalized];
  const entry = Object.entries(pagePermissions || {}).find(([pattern]) => (
    pattern.includes('/:') && matchesPattern(normalized, pattern)
  ));
  return entry?.[1] || null;
};

export const hasAdminPermission = (user, functionKey) => {
  if (!user || !functionKey) return false;
  if (user.isSuperAdmin === true) return true;
  return user.permissions?.[functionKey] === true;
};

export const canAccessAdminPath = (user, pathname) => {
  const functionKey = getPagePermission(pathname, user?.pagePermissions || ADMIN_PAGE_PERMISSIONS);
  return Boolean(functionKey && hasAdminPermission(user, functionKey));
};

export const getFirstAccessibleAdminPath = (user, pagePermissions = user?.pagePermissions || ADMIN_PAGE_PERMISSIONS) => (
  Object.entries(pagePermissions || {}).find(([pathname, functionKey]) => (
    !pathname.includes(':') && hasAdminPermission(user, functionKey)
  ))?.[0] || '/'
);

export const filterMenuGroupsByPermission = (groups, user) => (groups || [])
  .map((group) => ({
    ...group,
    items: (group.items || []).filter((item) => hasAdminPermission(
      user,
      item.permission || getPagePermission(item.path, user?.pagePermissions || ADMIN_PAGE_PERMISSIONS)
    ))
  }))
  .filter((group) => group.items.length > 0);
